export default "__VITE_ASSET__5T90qAAg__"